import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Cuentas por Pagar" },
  { label: "Compras",       icon: "fas fa-money-check-alt",     color: "#3b82f6", bg: "#eff6ff", href: "/ListadoComprasCXP",       desc: "Compras pendientes de pago", perm: "edoCtaProveedores" },
  { label: "Estado Cuenta", icon: "fas fa-file-invoice-dollar", color: "#6366f1", bg: "#eef2ff", href: "/EstadoCuentaCXP",          desc: "Estado de cuenta proveedor", perm: "edoCtaProveedores" },
  { label: "Abonos",        icon: "fas fa-dollar-sign",         color: "#10b981", bg: "#f0fdf4", href: "/ListadoAbonosProveedores", desc: "Pagos a proveedores",        perm: "pagoProveedores"   },
];

function BotonesCXP() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-file-invoice" color="#6366f1" bg="#eef2ff" title="Cuentas por Pagar" subtitle="Gestión de pagos a proveedores" />
        {user.pagoProveedores ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesCXP;
